import { Controller } from "@hotwired/stimulus"

// Shows/hides the Other Media subtype field on the book form based on the
// currently-selected "Type" radio. Wired to each kind radio's change event.
export default class extends Controller {
  static targets = ["otherMediaFields"]
  static values = { initialKind: String }

  connect() {
    this.refresh()
  }

  update() {
    this.refresh()
  }

  refresh() {
    if (!this.hasOtherMediaFieldsTarget) return
    const checked = this.element.querySelector('input[type="radio"][name*="[kind]"]:checked')
    const kind = checked ? checked.value : this.initialKindValue
    this.otherMediaFieldsTarget.classList.toggle("hidden", kind !== "other_media")
  }
}
